export default{
  title: '事例紹介',
  description: 'MaesInfoのエンタープライズアーキテクチャサービスが企業のデジタルトランスフォーメーションをどのように支援するかをご覧ください。',
  caseList: [
    {
      imgUrl: require('../../assets/images/cases/9.jpg'),
      title: 'グローバルオンラインゲーム「ゴーストシップ」',
      description: `
      1. 3Dゲームの没入感とリアリティ<br/>
      2. プレイヤーに高い自由度を提供し、ゲーム世界を自由に体験可能<br/>
      3. 3D技術はテクスチャ、動的な光影、天候変化、複雑なキャラクターモデルなど細部を表現します
      `
    },
    {
      imgUrl: require('../../assets/images/cases/10.jpg'),
      title: '賢江スマートファクトリー',
      description: `
      1. 主要工程の全工程自動化により人的介入を削減し、生産効率を向上<br/>
      2. 生産・設備・品質データのリアルタイム収集と表示で管理が透明化<br/>
      3. システムによる生産計画の自動最適化で納期を短縮
      `
    },
    {
      imgUrl: require('../../assets/images/cases/1.jpg'),
      title: 'スマートキャンパス管理システム',
      description: `
      1. スマートオフィスシステム、スタッフ管理システム<br/>
      2. スマートプロパティシステム（アクセス制御、スマート駐車、スマート水道/電力、企業管理）<br/>
      3. スマート防犯アラートシステム
      `
    },
    {
      imgUrl: require('../../assets/images/cases/2.jpg'),
      title: '生産情報管理システム',
      description: `
      1. 工程自動化プロセス管理とデータ収集システム<br/>
      2. 在庫管理、損耗分析、顧客追跡システム<br/>
      3. レポート生成システムと財務システム
      `
    },
    {
      imgUrl: require('../../assets/images/cases/3.jpg'),
      title: '金融管理システム',
      description: `
      1. 取引と会計を分離したコアシステム、総勘定元帳および財務管理システム<br/>
      2. 国際貿易向けの統一決済プラットフォーム<br/>
      3. チャネル統合プラットフォーム、ODSデータプラットフォーム
      `
    },
    {
      imgUrl: require('../../assets/images/cases/4.jpg'),
      title: '先物取引プラットフォーム',
      description: `
      1. エンタープライズデータウェアハウス、統一データ辞書と一貫したデータ定義<br/>
      2. セキュリティ状況可視化プラットフォーム、IT運用管理プラットフォーム<br/>
      3. 統合監視・アラート表示プラットフォーム
      `
    },
    {
      imgUrl: require('../../assets/images/cases/5.jpg'),
      title: 'ビッグデータ応用プラットフォーム（医療）',
      description: `
      1. デジタルスマート高齢者ケアクラウドプラットフォーム<br/>
      2. 医療業界向けクラウドアプリケーションプラットフォーム<br/>
      3. 医療画像解析プラットフォーム
      `
    },
    {
      imgUrl: require('../../assets/images/cases/6.jpg'),
      title: '海外ECプラットフォーム',
      description: `
      1. CRMシステム<br/>
      2. 商機予測分析データプラットフォーム<br/>
      3. オンラインショップサイトとモバイルアプリ
      `
    },
    {
      imgUrl: require('../../assets/images/cases/7.jpg'),
      title: 'グローバル越境サービスプラットフォーム',
      description: `
      1. Melinked越境サービスプラットフォーム<br/>
      2. B2Bマーケティング管理プラットフォーム<br/>
      3. 国際貿易決済プラットフォーム
      `
    },
    {
      imgUrl: require('../../assets/images/cases/8.jpg'),
      title: 'オンライン教育プラットフォーム',
      description: `
      1. ライブ教育プラットフォーム、講師と学生の教材をリアルタイムで共有<br/>
      2. 複数のモバイル端末をサポートするコミュニケーションプラットフォーム<br/>
      3. AIを活用したデジタル教育クラウドサービスプラットフォーム
      `
    }
  ]
}
